(ns dashboard.components.confirm-unsaved-answer
  (:require
   [dashboard.components.confirm-modal :refer [confirm-modal]]))

(defn modal-content []
  [:p "You have made changes that have not been saved."])

(defn confirm-unsaved-answer [{:keys [on-confirm]}]
  (partial #'confirm-modal
           {:title "You have unsaved changes"
            :content modal-content
            :label-confirm "Discard changes"
            :label-cancel "Keep editing"
            :invert-button-colors? true
            :notification-classes ["has-background-danger" "has-text-white" "is-shadowless"]
            :on-confirm on-confirm}))
